module.exports = __webpack_public_path__ + "media/images/weather/52_day_g-5aec2acbb04f005a6c68f080dc2a6798.png";